import React from "react";
import {
  Dialog,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextControl,
  FormControlLabel,
  Checkbox,
  Form,
  Box,
  Divider,
  Typography,
} from "@tiny/components";
import TinyImporterSample from "../TinyImporterSample/TinyImporterSample";
import { useTinyImportDialog } from "./TinyImportDialog.hooks";
import { TinyImportDialogProps } from "./TinyImporter.types";
import ManageCustomAttributesDialog from "../ManageCustomAttributesDialog/ManageCustomAttributesDialog";
import SettingsFuture from "@tiny/icons/generated/SettingsFuture";

function TinyImportDialog(props: TinyImportDialogProps) {
  const { open, onClose } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      disableEscapeKeyDown
      disableBackdropClose
    >
      <AddAudienceDialogContent {...props} />
    </Dialog>
  );
}

function AddAudienceDialogContent(props: TinyImportDialogProps) {
  const { onClose } = props;
  const [manageAttrsOpen, setManageAttrsOpen] = React.useState(false);

  const {
    setAllowAddAudiences,
    allowAddAudiences,
    form,
    handleSubmit,
    continueAdding,
    executing,
  } = useTinyImportDialog(props);

  return (
    <>
      <DialogTitle
        subtitle="Name your audience and upload your file."
        onClose={onClose}
      >
        Upload new audience
      </DialogTitle>
      <DialogContent>
        <Form form={form} onSubmit={handleSubmit}>
          <TextControl
            name="name"
            label="Name"
            defaultValue=""
            required
            maxLength={100}
            placeholder="Give your audience an easy to identify name"
          />
        </Form>

        <Box
          mt={4}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <TinyImporterSample />
          <Box
            display="inline-flex"
            alignItems="center"
            style={{ cursor: "pointer" }}
            onClick={() => setManageAttrsOpen(true)}
          >
            <SettingsFuture
              style={{
                width: 14,
                height: 14,
                marginRight: 6,
                color: "#9e9e9e",
              }}
            />
            <Typography variant="body2" color="primary" tone="main">
              Custom attributes
            </Typography>
          </Box>
        </Box>

        <Divider mt={4} />
      </DialogContent>
      <DialogActions
        extra={
          <FormControlLabel
            onChangeValue={setAllowAddAudiences}
            control={<Checkbox color="primary" checked={allowAddAudiences} />}
            label="I have the permission to send to these recipients."
          />
        }
      >
        <Button
          variant="contained"
          disabled={!allowAddAudiences || executing}
          onClick={continueAdding}
          loading={executing}
        >
          Continue
        </Button>
      </DialogActions>
      <ManageCustomAttributesDialog
        open={manageAttrsOpen}
        onClose={() => setManageAttrsOpen(false)}
      />
    </>
  );
}

export default TinyImportDialog;
